import { useCallback } from 'react';
import SLDTab from '../../sld/SLDTab';
import type { SLDConfig } from '../../sld/utils/sldTypes';
import type { SiteDetailTab } from '../SiteDetailTabs';

interface OneLineDiagramTabProps {
  siteId: string;
  sldConfig?: SLDConfig;
  /**
   * Switches the in-place site-detail tab. Provided by ProjectSummaryContent
   * so the SLD device-panel "View Details" button can jump to Site Overview
   * (#256). Optional so the tab still renders standalone.
   */
  onNavigateToTab?: (tab: SiteDetailTab) => void;
}

export default function OneLineDiagramTab({ siteId, sldConfig, onNavigateToTab }: OneLineDiagramTabProps) {
  // The SLD device panel's "View Details" button calls onNavigate('Overview', …);
  // map that request to the Site Overview in-place tab (#256).
  const handleNavigate = useCallback((tab: string) => {
    if (tab === 'Overview') {
      onNavigateToTab?.('site-overview');
    }
  }, [onNavigateToTab]);

  if (!sldConfig) {
    return (
      <div className="flex items-center justify-center min-h-[400px] text-ems-text-muted">
        <p>Site Overview not configured for this site</p>
      </div>
    );
  }

  return (
    <div className="relative w-full" style={{ height: 'calc(100vh - 220px)' }}>
      <SLDTab siteId={siteId} sldConfig={sldConfig} onNavigate={handleNavigate} />
    </div>
  );
}
